export const GET_ALL_VIEW_CASE_DETAILS = "GET_ALL_VIEW_CASE_DETAILS";
export const SET_ALL_VIEW_CASE_DETAILS = "SET_ALL_VIEW_CASE_DETAILS";
export const SET_LOADER = "SET_LOADER";
export const SET_CASE_ID = "SET_CASE_ID";
export const RESET_VIEW_CASE_DETAILS = "RESET_VIEW_CASE_DETAILS";
export const SET_COMMENTS_LOADER = "SET_COMMENTS_LOADER";
export const SET_COMMENTS_MODAL = "SET_COMMENTS_MODAL";
export const SET_COMMENTS = "SET_COMMENTS";
export const SET_COMMENT_ERR = "SET_COMMENTS_ERR";
export const SET_COMMENTS_SUBMIT = "SET_COMMENTS_SUBMIT";
export const SET_CANCEL_MODAL = "SET_CANCEL_MODAL";
export const RESET_ADD_COMMENTS = "RESET_ADD_COMMENTS";
export const RESET_COMMENT_ATTACHMENT = "RESET_COMMENT_ATTACHMENT";
export const ADD_COMMENT_ATTACHMENT_ERROR = "ADD_COMMENT_ATTACHMENT_ERROR";
export const ADD_COMMENT = "ADD_COMMENT";
export const SET_ATTACHMENTS_COMMENT = "SET_ATTACHMENTS_COMMENT";
export const SET_CASE_REPLY = "SET_CASE_REPLY";
export const SET_ENVIRONMNET = "SET_ENVIRONMNET";
export const SUBMIT_COMMENT_ATTACHMENT = "SUBMIT_COMMENT_ATTACHMENT";
export const DISABLE_COMMENT_CANCEL = "DISABLE_COMMENT_CANCEL";
export const COMMENT_ATTACHMENT_CHECK = "COMMENT_ATTACHMENT_CHECK";

export const ATTACHMENT_STATUS_RESPONSE = "FILE_STATUS_RESPONSE";
export const SET_ATTACHMENT_NAME = "SET_ATTACHMENT_NAME";
export const SET_ATTACHMENT = "SET_ATTACHMENT";
export const GET_ACTIVITY = "GET_ACTIVITY";
export const SET_ACTIVITY = "SET_ACTIVITY";
export const SET_ACTIVITY_ERROR = "SET_ACTIVITY_ERROR";
export const CLOSE_CASE = "CLOSE_CASE";
export const CLOSE_CASE_SUCCESS = "CLOSE_CASE_SUCCESS";
export const CLOSE_CASE_ERROR = "CLOSE_CASE_ERROR";
export const RESET_CLOSE_CASE = "RESET_CLOSE_CASE";

export const getAllViewCaseDetails = (isLoading = false) => {
  return {
    type: GET_ALL_VIEW_CASE_DETAILS,
    isLoading,
  };
};

export const setAllViewCaseDetails = (response) => {
  return {
    type: SET_ALL_VIEW_CASE_DETAILS,
    response,
  };
};

export const getActivity = () => {
  return {
    type: GET_ACTIVITY,
  };
};

export const setActivity = (response) => {
  return {
    type: SET_ACTIVITY,
    response,
  };
};

export const setActivityErr = (err) => {
  return {
    type: SET_ACTIVITY_ERROR,
    err,
  };
};

export const closeCase = () => {
  return {
    type: CLOSE_CASE,
  };
};

export const setCloseCaseSuccess = (response) => {
  return {
    type: CLOSE_CASE_SUCCESS,
    response,
  };
};

export const setCloseCaseError = (err) => {
  return {
    type: CLOSE_CASE_ERROR,
    err,
  };
};

export const resetCloseCase = () => {
  return {
    type: RESET_CLOSE_CASE,
  };
};

export const setCaseID = (value) => {
  return {
    type: SET_CASE_ID,
    value,
  };
};

export const setLoader = (value) => {
  return {
    type: SET_LOADER,
    value,
  };
};

export const resetViewCaseDetails = () => {
  return {
    type: RESET_VIEW_CASE_DETAILS,
  };
};

export const setCommentsLoader = (value) => {
  return {
    type: SET_COMMENTS_LOADER,
    value,
  };
};

export const setCommentsModal = (value) => {
  return {
    type: SET_COMMENTS_MODAL,
    value,
  };
};

export const setComments = (value) => {
  return {
    type: SET_COMMENTS,
    value,
  };
};

export const setCommentErr = (value) => {
  return {
    type: SET_COMMENT_ERR,
    value,
  };
};

export const setCommentsSubmit = (value) => {
  return {
    type: SET_COMMENTS_SUBMIT,
    value,
  };
};

export const setCancelModal = (value) => {
  return {
    type: SET_CANCEL_MODAL,
    value,
  };
};

export const resetAddComments = () => {
  return {
    type: RESET_ADD_COMMENTS,
  };
};

export const resetCommentAttachment = () => {
  return {
    type: RESET_COMMENT_ATTACHMENT,
  };
};

export const addCommentAttachmentError = (value, msg) => {
  return {
    type: ADD_COMMENT_ATTACHMENT_ERROR,
    value,
    msg,
  };
};

export const addComment = () => {
  return {
    type: ADD_COMMENT,
  };
};

export const setEnvironment = (value) => {
  return {
    type: SET_ENVIRONMNET,
    value,
  };
};
export const setCaseReplySuccess = (value) => {
  return {
    type: SET_CASE_REPLY,
    value,
  };
};
export function setCommentAttachmentCheck(value) {
  return {
    type: COMMENT_ATTACHMENT_CHECK,
    value,
  };
}

export const setAttachmentsComment = (value) => {
  return {
    type: SET_ATTACHMENTS_COMMENT,
    value,
  };
};
export function setDisableCommentCancel(value) {
  return {
    type: DISABLE_COMMENT_CANCEL,
    value,
  };
}
export function setSubmitCommentAttachment(value) {
  return {
    type: SUBMIT_COMMENT_ATTACHMENT,
    value,
  };
}

export function setAttachmentStatusResponse(value) {
  return {
    type: ATTACHMENT_STATUS_RESPONSE,
    value,
  };
}
export function setAttachmentName(value) {
  return {
    type: SET_ATTACHMENT_NAME,
    value,
  };
}
export function setAttachmentToBeUploaded(value) {
  return {
    type: SET_ATTACHMENT,
    value,
  };
}
